<template>
	<div class="c-global-checkout__form-section" v-if="modelValue" :id="('scrolltarget-' + fieldName)">
		<label>{{ label }}</label>
		<div>{{ modelValue }}</div>
	</div>
</template>

<script>
export default {
	name: "country-field",
	props: {
		label: {
			type: String,
			default: null,
		},
		modelValue: {
			type: String,
			default: null,
		},
		fieldName: {
			type: String,
			default: null,
		},
	},
};
</script>
